import React, { lazy, Suspense, useEffect, useState } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import Cursor from "./components/ui/Cursor";
import { getProjects } from "./database/database";
import CustomCursor from "./components/ui/CustomCursor";

const Home = lazy(() => import("./pages/Home"));
const Layout = lazy(() => import("./Layout"));
const About = lazy(() => import("./pages/About"));
const Skills = lazy(() => import("./pages/Skills"));
const Projects = lazy(() => import("./pages/projects/Projects"));
const ProjectDetails = lazy(() => import("./pages/projects/ProjectDetails"));
const Portfolio = lazy(() => import("./pages/projects/Portfolio"));
const Contact = lazy(() => import("./pages/Contact"));
const Recommendations = lazy(() => import("./pages/Recommendations"));
const Success = lazy(() => import("./pages/util/Success"));
const Privacy = lazy(() => import("./pages/util/Privacy"));
const NotFound = lazy(() => import("./pages/util/NotFound"));
const Mystery = lazy(() => import("./pages/Mystery"));

const isTouchDevice = () => {
  return "ontouchstart" in window || navigator.msMaxTouchPoints > 0;
};

const App = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    getProjects().then((data) => {
      data && setProjects(data);
    });
  }, []);

  const helmetContext = {};
  const [showCursor, setShowCursor] = useState(false);

  useEffect(() => {
    // locomotive scroll
    (async () => {
      const LocomotiveScroll = (await import("locomotive-scroll")).default;
      const locomotiveScroll = new LocomotiveScroll({
        autoResize: false,
        autoStart: false,
        duration: 0.2,
      });

      window.addEventListener(
        "resize",
        locomotiveScroll.resize.bind(locomotiveScroll)
      );
      setTimeout(() => {
        locomotiveScroll.start();
      }, 500);
    })();

    // cursor
    const timer = setTimeout(() => {
      setShowCursor(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <HelmetProvider context={helmetContext}>
      <BrowserRouter>
        <Suspense
          fallback={
            <div className="bg-surfaceColor-background h-[100vh] w-[100vw] fixed inset-0 flex items-center justify-center">
              <span className="loading loading-spinner loading-lg"></span>
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="skills" element={<Skills />} />
              <Route
                path="projects"
                element={<Projects projects={projects} />}
              />
              <Route
                path="projects/portfolio"
                element={<Portfolio />}
                projects={projects[6]}
              />
              ;
              {projects.map((project) => (
                <Route
                  key={project.id}
                  path={`/projects/${project.link}`}
                  element={<ProjectDetails projects={project} />}
                />
              ))}
              <Route path="contact" element={<Contact />} />
              <Route path="recommendations" element={<Recommendations />} />
              <Route path="success" element={<Success />} />
              <Route path="privacy" element={<Privacy />} />
              <Route path="mystery" element={<Mystery />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
        {/*{!isTouchDevice() && showCursor && <Cursor />}*/}
        {!isTouchDevice() && showCursor && <CustomCursor />}
      </BrowserRouter>
    </HelmetProvider>
  );
};

export default App;
